import { render, staticRenderFns } from "./IframeDialog.vue?vue&type=template&id=48616774&scoped=true"
import script from "./IframeDialog.vue?vue&type=script&lang=js"
export * from "./IframeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48616774",
  null
  
)

export default component.exports